export enum ContentSource {
  localStorage = 'local_storage',
}

export enum VRType {
  NONE = 'NONE',
  VR180 = '180',
  VR360 = '360',
}
export enum VideoResolution {
  HD = 'HD',
  FULL_HD = 'FULL_HD',
  HD_2K = 'HD_2K',
  HD_4K = 'HD_4K',
}

export enum VRFormat {
  twoD = '2d',
  threeDVertical = '3d-ver',
  threeDHorizontal = '3d-hor',
}

export interface NewContentCard {
  name: string;
  vrType: VRType;
  vrFormat: VRFormat;
  source: ContentSource;
  uri: string;
}

export enum ContentQuality {
  NORMAL = 'normal',
  GOOD = 'good',
  BEST = 'best',
}
export interface ContentCardLocale {
  id: string;
  code: string;
  name: string;
  image?: string;
  cloudUrl?: string;
  description?: string;
}

export interface ContentCard extends NewContentCard {
  id: string;
  image: string;
  imageVer?: string;
  cloudUrl: string;
  adult: boolean;
  archived: boolean;
  disabled: boolean;
  createdAt: string;
  updatedAt: string;
  isLocal: boolean;
  upscale: boolean;
  free: boolean;
  quality: ContentQuality;
  description?: string;
  duration?: number;
  ratingIndicators: { imdb: string; kinopoisk: string };
  locales: ContentCardLocale[];
  devices: string[];
  hdUrl: string;
  fullHdUrl: string;
  hd2kUrl: string;
  hd4kUrl: string;
  resolution?: string;
}
